export const lsColorLightTheme = {
  overlayNeutralSoft: '#0000000D',
  overlayNeutralStrong: '#00000080',
  overlayNeutralInvertedStrong: '#FFFFFF80',
  bgNeutralInertSofter: '#F1F2F7FF',
  bgNeutralInertSoft: '#D6D7DCFF',
  bgNeutralInertDefault: '#B1B1B5FF',
  bgNeutralSunken: '#E3E4E9FF',
  bgNeutralBackdrop: '#F1F2F7FF',
  bgNeutralEdge: '#E3E4E9FF',
  bgNeutralTop: '#FFFFFFFF',
  bgNeutralTopmost: '#FFFFFFFF',
  bgNeutralInvertedBackdrop: '#161619FF',
  bgNeutralInvertedTop: '#242427FF',
  bgNeutralDarkSoft: '#29292CFF',
  bgNeutralDarkDefault: '#1E1E21FF',
  bgNeutralDarkStrong: '#161619FF',
  bgGoHighlightDefault: '#B9C8FC29',
  bgGoHighlightStrong: '#869DFF29',
  bgGoSoft: '#4E58FDFF',
  bgGoDefault: '#3A1AFEFF',
  bgGoStrong: '#2B13C7FF',
  bgSuccessHighlightDefault: '#80E38429',
  bgSuccessHighlightStrong: '#31BC5429',
  bgSuccessSoft: '#158731FF',
  bgSuccessDefault: '#126A27FF',
  bgSuccessStrong: '#094F10FF',
  bgNoHighlightDefault: '#FFB8AD29',
  bgNoHighlightStrong: '#FF796A29',
  bgNoSoft: '#D3202FFF',
  bgNoDefault: '#AA2128FF',
  bgNoStrong: '#801617FF',
  bgWarningSoft: '#A95F22FF',
  bgWarningDefault: '#854D25FF',
  bgWarningStrong: '#693A1BFF',
  bgWarningHighlightDefault: '#F7BE7729',
  bgWarningHighlightStrong: '#EE861629',
  bgAiSoft: '#A633CCFF',
  bgAiDefault: '#8824A9FF',
  bgAiStrong: '#680E84FF',
  bgAiHighlightDefault: '#E7B2FC29',
  bgAiHighlightStrong: '#D575F929',
  bgSupplementarySoft: '#5177A2FF',
  bgSupplementaryDefault: '#365B85FF',
  bgSupplementaryStrong: '#193F66FF',
  bgSupplementaryHighlightDefault: '#B1CDEE29',
  bgSupplementaryHighlightStrong: '#80A8D529',
  fgNeutralSoft: '#69696DFF',
  fgNeutralDefault: '#1E1E21FF',
  fgNeutralInertSoft: '#A4A4A8FF',
  fgNeutralInertDefault: '#98989CFF',
  fgNeutralDarkSoft: '#525256FF',
  fgNeutralDarkDefault: '#1E1E21FF',
  fgNeutralInvertedSoft: '#E3E4E9FF',
  fgNeutralInvertedDefault: '#FFFFFFFF',
  fgNeutralOndarkInertSoft: '#808084FF',
  fgNeutralOndarkInertDefault: '#98989CFF',
  fgNeutralOndarkSoft: '#E3E4E9FF',
  fgNeutralOndarkDefault: '#FFFFFFFF',
  fgGoSoft: '#4E58FDFF',
  fgGoDefault: '#3217E3FF',
  fgGoStrong: '#1E0796FF',
  fgGoOndarkSoft: '#768EFDFF',
  fgGoOndarkDefault: '#A9BBFCFF',
  fgGoOndarkStrong: '#B9C8FCFF',
  fgSuccessSoft: '#158731FF',
  fgSuccessDefault: '#0F5C16FF',
  fgSuccessStrong: '#083A0CFF',
  fgWarningSoft: '#A95F22FF',
  fgWarningDefault: '#79421DFF',
  fgWarningStrong: '#4F270CFF',
  fgNoSoft: '#D3202FFF',
  fgNoDefault: '#941C1EFF',
  fgNoStrong: '#621512FF',
  fgAiSoft: '#A633CCFF',
  fgAiDefault: '#771695FF',
  fgAiStrong: '#4F0664FF',
  fgAiOndarkSoft: '#CB62F2FF',
  fgAiOndarkDefault: '#E3A0FDFF',
  fgAiOndarkStrong: '#E7B2FCFF',
  fgSupplementarySoft: '#5177A2FF',
  fgSupplementaryDefault: '#264B73FF',
  fgSupplementaryStrong: '#082F54FF',
  borderNeutralSoft: '#E3E4E9FF',
  borderNeutralStrong: '#C9CACFFF',
  borderNeutralStronger: '#8C8C90FF',
  borderNeutralInvertedSoft: '#333337FF',
  borderNeutralInvertedStrong: '#525256FF',
  borderNeutralInvertedStronger: '#8C8C90FF',
  borderNeutralOndarkSoft: '#48484CFF',
  borderNeutralOndarkStrong: '#69696DFF',
  borderNeutralOndarkStronger: '#8C8C90FF',
  borderGoSoft: '#586CFEFF',
  borderGoDefault: '#4142FDFF',
  borderGoStrong: '#3217E3FF',
  borderSuccessSoft: '#069638FF',
  borderSuccessDefault: '#0B7628FF',
  borderSuccessStrong: '#0F5C16FF',
  borderWarningSoft: '#BC6620FF',
  borderWarningDefault: '#965726FF',
  borderWarningStrong: '#79421DFF',
  borderNoSoft: '#EA2F37FF',
  borderNoDefault: '#C01D27FF',
  borderNoStrong: '#941C1EFF',
  borderAiSoft: '#B440DCFF',
  borderAiDefault: '#982ABBFF',
  borderAiStrong: '#771695FF',
  borderSupplementarySoft: '#5C83AFFF',
  borderSupplementaryDefault: '#466C96FF',
  borderSupplementaryStrong: '#264B73FF'
}
export const lsColorDarkTheme = {
  overlayNeutralSoft: '#FFFFFF1F',
  overlayNeutralStrong: '#00000080',
  overlayNeutralInvertedStrong: '#00000080',
  bgNeutralInertSofter: '#333337FF',
  bgNeutralInertSoft: '#3D3D41FF',
  bgNeutralInertDefault: '#48484CFF',
  bgNeutralSunken: '#060608FF',
  bgNeutralBackdrop: '#161619FF',
  bgNeutralEdge: '#1E1E21FF',
  bgNeutralTop: '#242427FF',
  bgNeutralTopmost: '#2F2F32FF',
  bgNeutralInvertedBackdrop: '#F1F2F7FF',
  bgNeutralInvertedTop: '#FFFFFFFF',
  bgNeutralDarkSoft: '#1E1E21FF',
  bgNeutralDarkDefault: '#000000FF',
  bgNeutralDarkStrong: '#000000FF',
  bgGoHighlightDefault: '#869DFF29',
  bgGoHighlightStrong: '#B9C8FC29',
  bgGoSoft: '#4E58FDFF',
  bgGoDefault: '#3A1AFEFF',
  bgGoStrong: '#2B13C7FF',
  bgSuccessHighlightDefault: '#31BC5429',
  bgSuccessHighlightStrong: '#80E38429',
  bgSuccessSoft: '#158731FF',
  bgSuccessDefault: '#126A27FF',
  bgSuccessStrong: '#094F10FF',
  bgNoHighlightDefault: '#FF796A29',
  bgNoHighlightStrong: '#FFB8AD29',
  bgNoSoft: '#D3202FFF',
  bgNoDefault: '#AA2128FF',
  bgNoStrong: '#801617FF',
  bgWarningSoft: '#A95F22FF',
  bgWarningDefault: '#854D25FF',
  bgWarningStrong: '#693A1BFF',
  bgWarningHighlightDefault: '#EE861629',
  bgWarningHighlightStrong: '#F7BE7729',
  bgAiSoft: '#A633CCFF',
  bgAiDefault: '#8824A9FF',
  bgAiStrong: '#680E84FF',
  bgAiHighlightDefault: '#D575F929',
  bgAiHighlightStrong: '#E7B2FC29',
  bgSupplementarySoft: '#5177A2FF',
  bgSupplementaryDefault: '#365B85FF',
  bgSupplementaryStrong: '#193F66FF',
  bgSupplementaryHighlightDefault: '#80A8D529',
  bgSupplementaryHighlightStrong: '#B1CDEE29',
  fgNeutralSoft: '#A4A4A8FF',
  fgNeutralDefault: '#E3E4E9FF',
  fgNeutralInertSoft: '#747478FF',
  fgNeutralInertDefault: '#808084FF',
  fgNeutralDarkSoft: '#525256FF',
  fgNeutralDarkDefault: '#1E1E21FF',
  fgNeutralInvertedSoft: '#3D3D41FF',
  fgNeutralInvertedDefault: '#29292CFF',
  fgNeutralOndarkInertSoft: '#808084FF',
  fgNeutralOndarkInertDefault: '#98989CFF',
  fgNeutralOndarkSoft: '#E3E4E9FF',
  fgNeutralOndarkDefault: '#FFFFFFFF',
  fgGoSoft: '#768EFDFF',
  fgGoDefault: '#A9BBFCFF',
  fgGoStrong: '#B9C8FCFF',
  fgGoOndarkSoft: '#768EFDFF',
  fgGoOndarkDefault: '#A9BBFCFF',
  fgGoOndarkStrong: '#B9C8FCFF',
  fgSuccessSoft: '#20AE45FF',
  fgSuccessDefault: '#65D573FF',
  fgSuccessStrong: '#80E384FF',
  fgWarningSoft: '#E17914FF',
  fgWarningDefault: '#F7AC55FF',
  fgWarningStrong: '#F7BE77FF',
  fgNoSoft: '#F96053FF',
  fgNoDefault: '#FFA597FF',
  fgNoStrong: '#FFB8ADFF',
  fgAiSoft: '#CB62F2FF',
  fgAiDefault: '#E3A0FDFF',
  fgAiStrong: '#E7B2FCFF',
  fgAiOndarkSoft: '#CB62F2FF',
  fgAiOndarkDefault: '#E3A0FDFF',
  fgAiOndarkStrong: '#E7B2FCFF',
  fgSupplementarySoft: '#749CC9FF',
  fgSupplementaryDefault: '#A3C1E5FF',
  fgSupplementaryStrong: '#B1CDEEFF',
  borderNeutralSoft: '#333337FF',
  borderNeutralStrong: '#525256FF',
  borderNeutralStronger: '#8C8C90FF',
  borderNeutralInvertedSoft: '#E3E4E9FF',
  borderNeutralInvertedStrong: '#C9CACFFF',
  borderNeutralInvertedStronger: '#8C8C90FF',
  borderNeutralOndarkSoft: '#48484CFF',
  borderNeutralOndarkStrong: '#69696DFF',
  borderNeutralOndarkStronger: '#8C8C90FF',
  borderGoSoft: '#4142FDFF',
  borderGoDefault: '#586CFEFF',
  borderGoStrong: '#869DFFFF',
  borderSuccessSoft: '#0B7628FF',
  borderSuccessDefault: '#069638FF',
  borderSuccessStrong: '#31BC54FF',
  borderWarningSoft: '#965726FF',
  borderWarningDefault: '#BC6620FF',
  borderWarningStrong: '#EE8616FF',
  borderNoSoft: '#C01D27FF',
  borderNoDefault: '#EA2F37FF',
  borderNoStrong: '#FF796AFF',
  borderAiSoft: '#982ABBFF',
  borderAiDefault: '#B440DCFF',
  borderAiStrong: '#D575F9FF',
  borderSupplementarySoft: '#466C96FF',
  borderSupplementaryDefault: '#5C83AFFF',
  borderSupplementaryStrong: '#80A8D5FF'
}
